import script from "./single-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./single-card.vue?vue&type=script&setup=true&lang=ts"

import "./single-card.vue?vue&type=style&index=0&id=21b692be&lang=scss"

const __exports__ = script;

export default __exports__